"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FungibleTokenMetadataToJSON = exports.FungibleTokenMetadataFromJSONTyped = exports.FungibleTokenMetadataFromJSON = void 0;
function FungibleTokenMetadataFromJSON(json) {
    return FungibleTokenMetadataFromJSONTyped(json, false);
}
exports.FungibleTokenMetadataFromJSON = FungibleTokenMetadataFromJSON;
function FungibleTokenMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token_uri': json['token_uri'],
        'name': json['name'],
        'description': json['description'],
        'image_uri': json['image_uri'],
        'image_canonical_uri': json['image_canonical_uri'],
        'symbol': json['symbol'],
        'decimals': json['decimals'],
        'tx_id': json['tx_id'],
        'sender_address': json['sender_address'],
    };
}
exports.FungibleTokenMetadataFromJSONTyped = FungibleTokenMetadataFromJSONTyped;
function FungibleTokenMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token_uri': value.token_uri,
        'name': value.name,
        'description': value.description,
        'image_uri': value.image_uri,
        'image_canonical_uri': value.image_canonical_uri,
        'symbol': value.symbol,
        'decimals': value.decimals,
        'tx_id': value.tx_id,
        'sender_address': value.sender_address,
    };
}
exports.FungibleTokenMetadataToJSON = FungibleTokenMetadataToJSON;
//# sourceMappingURL=FungibleTokenMetadata.js.map